import {createRef} from "../createRef";

export default createRef({
    "id": "didox_status_ref",
    "source": "didox_status_ref",
    "fields": [
        {"column": "id"},
        {"column": "name"}
    ]
});
